
import PageBanner from "@/src/components/PageBanner";
import Layout from "@/src/layout/Layout";
import { client, urlFor } from "../lib/client";
import { Fragment, useState } from "react";
import toast  from "react-hot-toast";
import axios from "axios";
import { NextSeo, ArticleJsonLd } from 'next-seo';
import React, { useRef  } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { imageScale } from "@/src/utils/motion";
import useMouseOver from "@/src/hooks/useMouseOver";
import { initialValues,  } from "@/src/datas/formData";
import { formValidationSchema } from "@/src/utils/formValidations";
import InputComponent from "@/src/components/InputComponent";
import { sendEmail,sendEmailToCustomer,sendDataToSheets } from "@/src/components/lib/sendEmail";
import timeStampGenerator from "@/src/components/lib/timeStampGenerator";
import PhoneInputCustom from "@/src/components/PhoneInputCustom";
import useClientIP from "@/src/hooks/useClientIP";
import { useRouter } from "next/router";
import useDynamicFormik from "@/src/hooks/useDynamicFormik";
import UseAnimationIos from "@/src/pages/api/useAnimationIos";

const Contact = ({  fetchHeader, fetchFooter, contactPage, fHeaderMenuData}) => {
  const { pageBuilder, seo } = contactPage;
  const {  contactSectionFirst, contactSectionSecond, maps } = pageBuilder

  const {canonical, jsonLtd, metaDescription, metaTitle, seo_image, type, url } = seo
  const bgImage = urlFor(contactSectionFirst.hero_image);

// form submit

const [form, setForm] = useState({ name: "", email: "", message: "" });
const [loading, setLoading] = useState(false);
const handleChange = (e) => {
  const { name, value } = e.target;
  setForm({ ...form, [name]: value });
};
const handleSubmitSecond = async () => {

  setLoading(true)
  try {
    const sendEmail = await axios.post('/api/send-email', {
      subject: "Query Form From Website",
      toEmail: 'ishariqriaz@gmail.com',
      text: form.name,
      html_text: `
      <div style="font-family: Arial, sans-serif; border: 1px solid #cccccc; padding: 20px; max-width: 600px; margin: 0 auto;">
        <h2 style="color: #333333;">Hello , ${form.name} </h2>
        <p style="color: #333333;">Thank you for your purchase!</p>
        <p style="color: #333333;">Order Details:</p>
        <ul style="list-style-type: none; padding: 0;">

          <li style="color: #333333;">Customer Contact information:  </li>
          <li style="color: #333333;">Customer Name:  ${form.name} </li>
          <li style="color: #333333;">Customer Phone:  ${form.phone} </li>
          <li style="color: #333333;">Customer Email:  ${form.email} </li>
          <li style="color: #333333;">Customer Message:  ${form.message} </li>


        </ul>
        <p style="color: #333333;">If you have any questions, feel free to reply to this email.</p>
        <p style="color: #333333;">Thank you,</p>
        <p style="color: #333333;">Techcelerant</p>
      </div>
    `,
    });
    if(sendEmail.data === 'Success'){
      setLoading(false);
      
    }
    else {
      toast.error("Please Retry again.");
      setLoading(false)
    }
  } catch (error) {
    console.log(error.message);
    setLoading(false)
  }
};
const handleSubmit = async (e) => {
  e.preventDefault();  
  setLoading(true)
  try {
    const sendEmail = await axios.post('/api/send-email', {
      subject: "Query Form From Website",
      toEmail: 'dev.techriffic@gmail.com',
      text: form.name,
      html_text: `
      <div style="font-family: Arial, sans-serif; border: 1px solid #cccccc; padding: 20px; max-width: 600px; margin: 0 auto;">
        <h2 style="color: #333333;">Hello , ${form.name} </h2>
        <p style="color: #333333;">Thank you for your purchase!</p>
        <p style="color: #333333;">Order Details:</p>
        <ul style="list-style-type: none; padding: 0;">

          <li style="color: #333333;">Customer Contact information:  </li>
          <li style="color: #333333;">Customer Name:  ${form.name} </li>
          <li style="color: #333333;">Customer Phone:  ${form.phone} </li>
          <li style="color: #333333;">Customer Email:  ${form.email} </li>
          <li style="color: #333333;">Customer Message:  ${form.message} </li>


        </ul>
        <p style="color: #333333;">If you have any questions, feel free to reply to this email.</p>
        <p style="color: #333333;">Thank you,</p>
        <p style="color: #333333;">Techcelerant</p>
      </div>
    `,
    });
    if(sendEmail.data === 'Success'){
      toast.success("Thank you!, Our representative will contact You.");
      setLoading(false);
      handleSubmitSecond();

    }
    else {
      toast.error("Please Retry again.");
      setLoading(false);
      handleSubmitSecond();
    }
  } catch (error) {
    console.log(error.message);
    setLoading(false)
  }
};

//my
const isMobile = useMediaQuery("(max-width:786px)");
const isPixelActive = useMouseOver();
const router = useRouter;

const [selectedOption, setSelectedOption] = useState(null);
const [selectedOptionBudget, setSelectedOptionBudget] = useState(null);
const [selectProjectBegin, setSelectProjectBegin] = useState(null);
const [selectHiringDecision, setSelectHiringDecision] = useState(null);
const [isFormSubmited, setIsFormSubmited] = useState(false);
const [selectedTime, setSelectedTime] = useState("");
const [recaptchaToken, setRecaptchaToken] = useState("");
const [showCaptchaError, setShowCaptchaError] = useState(false);

const [value, setValue] = useState();
const ipAddress = useClientIP();

//useEffect(() => {
 // if (showCaptchaError === true) {
  //  setShowCaptchaError(false);
 // }
//}, [recaptchaToken]);

const handleTimeChange = (timeZone, timeSlot) => {
  //ask
  const timeToCall = `${timeZone} ${timeSlot?.start ? timeSlot?.start : ""} - ${timeSlot?.end ? timeSlot?.end : ""}`;
  setSelectedTime(timeToCall);
};

const onSubmit = async () => {
  const form_service_type =
    selectedOption?.map((option) => option.label).join(", ") ||
    "";
  const form_service_type_budget = selectedOptionBudget?.value
    ? selectedOptionBudget.value
    : "";

  const form_service_type_projectBegin = selectProjectBegin?.value
    ? selectProjectBegin.value
    : "";

  const form_service_type_hiringDecision = selectHiringDecision?.value
    ? selectHiringDecision.value
    : "not selected";

  try {

    const utcMinus11Timestamp = timeStampGenerator();
    let split_data = utcMinus11Timestamp.split(', ')
let date_str = split_data[0]
let time_str = split_data[1]

const formatPhoneNumber = (phoneNumber) => {
const cleaned = ('' + phoneNumber).replace(/\D/g, '');
const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
if (match) {
    return `(${match[2]}) ${match[3]}-${match[4]}`;
}
return phoneNumber;
};

const formattedPhoneNumber = formatPhoneNumber(formik.values.phone);

    const ipaddress = ipAddress; 

 
    

      
  //  sendLeadEvent(
    //  "Lead",
    //  formik,
    //  "Content Form Submit",
    //  router.pathname,
   //   isPixelActive,
   // );



    const newRow = {
      Date: date_str,
       // Time: time_str,
       State: "",
       Source: "Get Started",
       Assigned: "",
       Status: "Fresh",
       Name: formik.values.name,
       Email: formik.values.email,
       Number: formattedPhoneNumber,
       Company: "",
       "Client\nNotes": `${formik.values.message} ${ipAddress ? ('/') : ('')} ${ipAddress}`,
    };
    setIsFormSubmited(true);
    const gSheets = await sendDataToSheets(newRow);
    formik.setStatus({
      success: true,
      message: "Form submitted successfully",
    });

    if (!isVisible) {
      close(false);
    }
    // toast.success("Thank you!, Our representative will contact You.");
    setIsFormSubmited(true);
    if (!isVisible) {
      close(false);
    }
    
    const emailResponse = await sendEmail(
      formik,
      form_service_type_budget,
      form_service_type,
      form_service_type_projectBegin,
      form_service_type_hiringDecision,
      newRow,
      ipAddress,
    );

    const sendEmailToUser = await sendEmailToCustomer(
      formik,
      form_service_type_budget,
      form_service_type,
      form_service_type_projectBegin,
      form_service_type_hiringDecision,
      newRow,
    );

    if (emailResponse.data === "Success") {
      formik.setStatus({
        success: true,
        message: "Form submitted successfully",
      });

      if (!isVisible) {
        close(false);
      }
      // toast.success("Thank you!, Our representative will contact You.");
      setIsFormSubmited(true);
      if (!isVisible) {
        close(false);
      }
    }
    else {
      formik.setStatus({ success: false, message: "Submission error" });

      toast.error("Please Retry again.");
    }
 
    // }
    // else {
    //     // Handle error
    //     console.error(data.message);
    //     toast.error("Please refill captcha");

    // }
  } catch (error) {
    /* eslint-disable */
    console.log(error.message);
    formik.setStatus({ success: false, message: error.message });
  }
};

const formik = useDynamicFormik(
  initialValues,
  formValidationSchema,
  onSubmit,
);

// if(formik?.status?.success === true) {
//   close
//   return (
//     <div className='bg-white p-10 rounded-xl text-2xl'> Thanks For Filling the form </div>
//   )

// }

const [onScreen, setOnScreen] = useState(false);
const ref = useRef();
const formRef = useRef();
UseAnimationIos(ref, setOnScreen);
const animation = onScreen
  ? imageScale(1.5).animate
  : imageScale(0.5).initial;

const onRecaptchaChange = (token) => {
  setRecaptchaToken(token);
};

  return (
    <Fragment>
        <NextSeo
            title={metaTitle}
            description={metaDescription}
            canonical={canonical}
            robots="index, follow"
            openGraph={{
              type: type,
              url: url,
              title: metaTitle,
              description: metaDescription,
              image: urlFor(seo_image).url(),
            }} 
            additionalLinkTags={[
              {
                rel: 'icon',
                href: '/assets/images/favicon.png',
              },
              {
                rel: 'apple-touch-icon',
                href: 'https://www.test.ie/touch-icon-ipad.jpg',
                sizes: '76x76'
              },
             ]}
        />
        <ArticleJsonLd
     dataArray={JSON?.parse(jsonLtd)}
        />
    <Layout footerData={fetchFooter} menuData={fHeaderMenuData}  headerData={fetchHeader}>
      {/* Page Banner Start */}
      <PageBanner bgImage={bgImage} pageName={"Contact"} />
      {/* Page Banner End */}
      {/* Contact Form Area start */}
      <section  className="contact-page-area py-130 rpy-100 rel z-1">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-6">
              <div className="our-location-part rmb-55  fadeInUp delay-0-2s">
                <div className="row">
                  <div className="col-xl-10">
                    <div className="section-title mb-60">
                      <span className="sub-title mb-15"> {contactSectionFirst.heading} </span>
                      <h2>
                        {contactSectionSecond.main_heading}
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="row gap-80 pb-30">
                  {contactSectionSecond.services_items.map((item, index) => (
  <div key={index} className="col-sm-6">
  <div className="our-location-address mb-40">
    <h3> {item.name} </h3>
    <p>
    {item.address}
    </p>
    <a className="mailto" href={`mailto:${item.name}`}>
    {item.email}
    </a>
    <br />
    <a className="callto" href={`callto:${item.phone}`}>
      <i className={item.flat_icon} />   {item.phone}
    </a>
  </div>
</div>
                  ))}

                </div>
                <h3>Follow Us</h3>
                <div className="social-style-two pt-15">
  {contactSectionSecond.socials.map((item, index) => (
    <a key={index} href={item.link}>
      <i className={`fab fa-${item.platform === 'linkedin' ? 'behance' : item.platform}`} />
    </a>
  ))}
  <a href="#">
    <i className="fab fa-dribbble" />
  </a>
  
</div>

              </div>
            </div>
            <div className="col-xl-5 col-lg-6">
              <div className="contact-page-form form-style-one  fadeInUp delay-0-2s">
                <div className="section-title mb-35">
                  <span className="sub-title mb-15">Get Free Quote</span>
                  <h3>Drop Us a Message</h3>
                </div>
                <form
                  id="contactForm"
                  className="contactForm"
                  ref={formRef}
                  onSubmit={formik.handleSubmit}
                  name="contactForm"
                  method="POST"
                >
                  <div className="row gap-60 pt-15">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="name" className="mt-10 pt-5">
                          <i className="far fa-user" />
                        </label>
                      {/*}  <input
                          type="text"
                          id="name"
                          name="name"
                          className={`form-control `}
                          defaultValue
                          value={formik.values.name}
                          //onChange={handleChange}
                          placeholder="Full Name"
                          required
                          data-error="Please enter your name"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                  /> */}
                 <InputComponent
                  required={true}
                  className="w-[100%] border-b-[5px] border-gray-300 text-gray-800 outline-none"
                  value="name"
                  placeholder="Full Name"
                  formik={formik}
                />
                {/*}  {<p className="txtclrcontact">{formik.errors.name}</p>} */}
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        
                       {/*} <input
                          type="text"
                          id="phone"
                          name="phone"
                          className="form-control"
                          
                          value={formik.values.phone}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="Phone number"
                          required
                          data-error="Please enter your Number"
                /> */}
               <PhoneInputCustom
                  formik={formik}
                  className=" "
                />
                  
                        <div className="help-block with-errors" />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="email" className="mt-10 pt-5">
                          <i className="far fa-envelope" />
                        </label>
                        {/*<input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          defaultValue
                          placeholder="Email Address"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}      
                          required
                          data-error="Please enter your Email Address"
              /> */}
              <InputComponent
                          required={true}
                          className=" border-b-[5px] border-gray-300  w-[100%]  text-gray-800 outline-none"
                          value="email"
                          placeholder="Email"
                          formik={formik}
                  />
                
                        <div className="help-block with-errors" />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="message" className="mt-10 pt-5">
                          <i className="far fa-pencil" />
                        </label> 
                        {/*}
                        <textarea
                          name="message"
                          id="message"
                          className="form-control"
                          rows={2}
                          placeholder="Message"
                          required
                          value={formik.values.message}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}              
                                    data-error="Please enter your Message"
                          defaultValue={""}
                        />
            */}
 <textarea
                    name="message"
                    id="message"
                    className="   txtfieldscontact"
                    value={formik.values.message}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    rows={4}
                    placeholder="Type your message here"
                  />
                  {formik.touched.message && formik.errors.message ? (
                    <div className="error">{formik.errors.message}</div>
                  ) : null}
                
                        <div className="help-block with-errors" />
                      </div>
                    </div>
  {/*}                  <div className="col-md-12">
                    <div className="form-group">
                        
                 
                        {showCaptchaError && (
                    <p className="text-[13px] text-red-600 py-2">
                      {" "}
                      Please fill recaptcha{" "}
                    </p>
                  )}
                  <ReCAPTCHA
                    sitekey={`${process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY}`} // Replace with your site key
                    onChange={onRecaptchaChange}
                  />
                
                        <div className="help-block with-errors" />
                      </div>
</div> */}
                    <div className="col-md-12">
                      <div className="form-group pt-5 mb-0">
                        {isFormSubmited ? (
                            <button
                            disabled
                            type="submit"
                            className={`theme-btn style-two w-100 `}
                          >
                            Sent
                          </button>
                        ): (
                          <button
                          disabled={formik.isValid && !formik.isSubmitting ? false : true}
                          type="submit"
                          className={`theme-btn style-two w-100 ${formik.isValid && !formik.isSubmitting ? "  form-buttom-submit  text-success" : "text-danger"} text-white rounded-full cursor-pointer` }
                        >
                       {formik.isSubmitting ? "Sending..." : "Submit"}   <i className="far fa-arrow-right" />
                        </button>
                        )}
                        
                        
                 {/*}       <button
                          type="submit"
                          className="theme-btn style-two w-100"
                        >
                       {loading ? 'Submitting' : ' Send Message us' }   <i className="far fa-arrow-right" />
                        </button> */}
                        <div id="msgSubmit" className="hidden" />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Form Area end */}
      {/* Location Map Area Start */}
      <div className="contact-page-map mb-120 rpb-90  fadeInUp delay-0-2s">
        <div className="container-fluid">
          <div className="our-location">
            <iframe
              src={maps}
              style={{ border: 0, width: "100%" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>

      {/* Location Map Area End */}
      {/* footer area start */}
    </Layout>
    </Fragment>
  );
};

export const getServerSideProps = async () => {
  const query = `*[ _type == "contactPage"][0]`;
  const contactPage = await client.fetch(query);

    // fetching layouts
    const queryForFooter = `*[ _type == "Footer"  ][0]`;
    const fetchFooter = await client.fetch(queryForFooter);
  
    const queryForHeader = `*[ _type == "Header"  ][0]`;
    const fetchHeader = await client.fetch(queryForHeader);

 // fetching header data
 const headMenuData = `*[ _type == "Header"  ]{
  menu_items[]->{
           title,
           slug,
           menu_name,
           menu_name_number,
 }
}[0]`;
const fHeaderMenuData =  await client.fetch(headMenuData);
const headerDataForMenu = fHeaderMenuData.menu_items;


    return {
      props:   {
        fetchHeader, fetchFooter, contactPage,fHeaderMenuData: headerDataForMenu,
      }
    }
}

export default Contact;
